class PaymentSetting {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}

export class Driver {
  id: string;
  name: string;
  email: string;
  client: string;
  clients: string[];
  image: string;
  mobile_no: string;
  vehicle_type: string;
  employee_code: string;
  blocked: boolean;
  status: string;
  payment_setting: PaymentSetting | string | null;
  wallet_payment_type: string;
  hub_ids: string;
  hubs: string;
  created_by?: string;
  created_at?: Date;
  last_login?: Date;
  first_trip?: Date;
  last_trip?: Date;

  constructor(args: any) {
    this.id = args.id;
    this.name = args.name;
    this.email = args.email;
    this.client = args.client;
    this.clients = args.clients;
    this.image = args.image;
    this.mobile_no = args.mobile_no;
    this.vehicle_type = args.vehicle_type;
    this.employee_code = args.employee_code;
    this.blocked = args.blocked;
    this.status = args.blocked ? 'Suspended' : 'Active';
    this.payment_setting = args.payment_setting
      ? new PaymentSetting(args.payment_setting.id, args.payment_setting.name)
      : null;
    this.wallet_payment_type = args.wallet_payment_type;
    this.hub_ids = args.hub_ids;
    this.hubs = args.hubs;
    this.created_by = args.created_by;
    this.created_at = args.created_at;
    this.last_login = args.last_login;
    this.first_trip = args.first_trip;
    this.last_trip = args.last_trip;
    this.hub_ids = args.hub_ids;
  }
}
